module.exports = __webpack_public_path__ + "media/newstyle/images/icon-lp-3-red-46f907a6709852402b0dbebe40a9ce3d.svg";